<script lang="ts">
	const { goalUri }: { goalUri?: string } = $props();
</script>

<svelte:head>
	{#if goalUri}
		{@html `
		<script>
			window._actGoal = {
				settings: {
					value: '${goalUri}',
					type: 'WEBSITE_VISIT',
					goalUrl: 'https://www.actito.be:443/actg'
				}
			};
		</script>
		<script async defer src="https://cdn.actito.be/actito-goal/goal.js"></script>
		`}
	{/if}
</svelte:head>
